module.exports = __webpack_public_path__ + "img/ic-electroncard.fc571bbf.svg";